import React from 'react';
import { motion } from 'framer-motion';
const PAIN_POINTS = [{
  emoji: '😤',
  text: 'Comprás packs de planificaciones que cuando los abrís son genéricos, hechos con IA mediocre y no sirven para tus alumnos reales.'
}, {
  emoji: '⏰',
  text: 'Pasás horas del domingo planificando cuando podrías estar con tu familia o simplemente descansando.'
}, {
  emoji: '💸',
  text: 'Gastás en PDFs de "especialistas" que son copias de ChatGPT mal hecho, vendidos a precio de oro.'
}, {
  emoji: '😰',
  text: 'Querés usar IA pero no sabés exactamente cómo pedirle lo que necesitás sin recibir basura genérica.'
}, {
  emoji: '📚',
  text: 'Reutilizás planificaciones viejas porque no tenés tiempo de crear material nuevo adaptado a tus alumnos.'
}, {
  emoji: '🔄',
  text: 'El ciclo no para: buscás, comprás, te decepcionás, repetís. Es agotador y costoso.'
}];
export function PainSection() {
  return <section className="py-20 bg-zinc-950" data-id="element-191">
      <div className="max-w-5xl mx-auto px-4" data-id="element-192">
        <div className="text-center mb-16" data-id="element-193">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-black uppercase tracking-tight text-white mb-4" data-id="element-194">
            ¿Te Suena Familiar?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-195">
            Sos docente. Trabajás más que nadie. Y el domingo sigue siendo tuyo
            solo de nombre.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-196">
          {PAIN_POINTS.map((point, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-zinc-900 border-l-4 border-red-500 rounded-r-lg p-6 shadow-lg" data-id="element-197">
              <div className="flex items-start gap-4" data-id="element-198">
                <span className="text-3xl flex-shrink-0" data-id="element-199">{point.emoji}</span>
                <p className="text-gray-300 leading-relaxed" data-id="element-200">{point.text}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-yellow-500/10 border-l-4 border-yellow-500 p-8 md:p-10 rounded-r-xl text-center max-w-3xl mx-auto" data-id="element-201">
          <p className="text-xl md:text-2xl text-yellow-500 font-medium italic leading-relaxed" data-id="element-202">
            "El problema no sos vos. Es que nadie te enseñó a usar la IA
            correctamente para tu trabajo real."
          </p>
        </motion.div>
      </div>
    </section>;
}